/**
 * Shopify money format utility
 * Formats money values according to the specified format string
 */

if (typeof Shopify === "undefined") {
  var Shopify = {};
}

/**
 * Formats a money value based on the shop's currency format
 *
 * @param {number} cents - The price in cents
 * @param {string} format - The money format string (e.g. "€{{amount}}")
 * @returns {string} The formatted money string
 */
Shopify.formatMoney = function (t, r) {
  function e(t, r) {
    return void 0 === t ? r : t;
  }

  function a(t, r, a, o) {
    if (
      ((r = e(r, 2)), (a = e(a, ",")), (o = e(o, ".")), isNaN(t) || null == t)
    )
      return 0;

    t = (t / 100).toFixed(r);
    var n = t.split(".");
    return (
      n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) +
      (n[1] ? o + n[1] : "")
    );
  }

  "string" == typeof t && (t = t.replace(".", ""));

  var o = "",
    n = /\{\{\s*(\w+)\s*\}\}/,
    i = r || this.money_format;

  if (!i || !i.match(n)) {
    i = "€{{amount}}";
  }

  switch (i.match(n)[1]) {
    case "amount":
      o = a(t, 2);
      break;
    case "amount_no_decimals":
      o = a(t, 0);
      break;
    case "amount_with_comma_separator":
      o = a(t, 2, ".", ",");
      break;
    case "amount_with_space_separator":
      o = a(t, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      o = a(t, 2, " ", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      o = a(t, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      o = a(t, 0, " ", "");
      break;
    case "amount_with_apostrophe_separator":
      o = a(t, 2, "'", ".");
      break;
    case "amount_with_decimal_separator":
      o = a(t, 2, ".", ".");
  }

  return i.replace(n, o);
};
